import React, { useState } from 'react';
import { Button, Card, CardBody, Container, Label, Row, Col } from 'reactstrap';
import PDF from "react-pdf-js";
import PdfViewer from '../GreeetingMaterial/PdfViewer';
import useDeviceDetection from '../../hooks/useDeviceDetection';
import data from './data.js'

const TreePdfViewer = () => {
    const [selectedPdf, setSelectedPdf] = useState(null);
    const device = useDeviceDetection();

    const handleClick = (pdfPath) => {
        setSelectedPdf(pdfPath);
    };

    return (
        <div className="simple-container">
            <div className="pt-3">
                <Container>

                    <Row className='pt-5'>
                        {data.map((item, index) => {
                            // Extract title from PDF path
                            const fileName = item.path.split('/').pop().replace('.pdf', '');
                            const title = fileName.split(' ').slice(0, 8).join(' '); // Take first 8 words
                            
                            return (
                                <Col md={6} lg={4} key={index}>
                                    <Card className="card-shadow" style={{ height: "560px", display: "flex", flexDirection: "column" }}>
                                        <div style={{ 
                                            minHeight: device == 'Mobile' ? '200px' : '300px',
                                            width: '100%',
                                            textAlign: 'center'
                                        }}>
                                                <PDF
                                                    scale={device == 'Mobile' ? 0.3 : 0.5}
                                                    file={item.path || null}                        
                                                />
                                        </div>
                                        <CardBody className="news-card" style={{ flex: "1" }}>
                                            <div className="">
                                                <Label className="news-title" style={{overflowWrap:'anywhere'}}>
                                                    {title}
                                                </Label>
                                            </div>
                                        </CardBody>
                                        <div style={{ marginLeft: '10px' }}>
                                            <Button onClick={() => handleClick(item.path)} className='btn-basic-org mb-3 font-15 pl-5'>Details</Button>
                                        </div>
                                    </Card>
                                </Col>
                            );
                        })}
                    </Row>
                </Container>
            </div>

            <PdfViewer pdf={selectedPdf} onCancel={() => setSelectedPdf(null)} visible={!!selectedPdf} />
        </div>
    );
}

export default TreePdfViewer;
